import comp from "./DocEditorWrapper";
export default comp;
